import { apiPayment } from 'api'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { I18n } from 'react-redux-i18n'
import { getStaticImage } from 'utils/statics'
import './styles.scss'

const InfoPayment = ({ userId, orderId }) => {
  const [orderInfo, setOrderInfo] = useState({})
  const [orderError, setOrderError] = useState('')

  useEffect(() => {
    getOrder()
  }, [])

  const getOrder = async () => {
    try{
      const order = await apiPayment.getOrderId({ userId, orderId })
      setOrderInfo(order.data)

    } catch (error) {
      setOrderError(I18n.t('message_error_data_list_distribution'))
    }
  }
  const { orderNumber='', bussinessNumber='', total=0, totalRefund=0, currency='eur', priceLeft=0, terminal=0, date: orderDate, concepto='', authorization='', provider='' } = orderInfo
  const [date, time] = moment(orderDate).format('DD/MM/YYYY HH:mm').split(' ')
  return (
    <div className='container-info-payment'>
      {orderError.length > 0 && <div className='error-container'>
        <span className='text-danger'>{orderError}</span>
      </div>}
      {/* comercion y pedido */}
      <div className='section-container'>
        <div className='section-data'>
          <label className='title-data'>{I18n.t('dashboard_payment_order_number')}</label>
          <label className='content-data'>{orderNumber}</label>
        </div>
        <div className='section-data' style={{ width:'80%' }}>
          <label className='title-data'>{I18n.t('dashboard_payment_trade_number')}</label>
          <label className='content-data'>{bussinessNumber}</label>
        </div>
      </div>
      {/*  importe y reembolso total */}
      <div className='section-container'>
        <div className='section-data'>
          <label className='title-data'>{I18n.t('dashboard_payment_amount')}</label>
          <label className='content-data'>{total} <i className={`fa fa-${currency.toLowerCase()} content-data`}></i></label>
        </div>
        <div className='section-data' style={{ width:'80%' }}>
          <label className='title-data'>{I18n.t('dashboard_payment_total_refund')}</label>
          <label className='content-data'>{totalRefund} <i className={`fa fa-${currency.toLowerCase()} content-data`}></i></label>
        </div>
      </div>
      {/* valor reembolsable y terminal */}
      <div className='section-container'>
        <div className='section-data'>
          <label className='title-data'>{I18n.t('dashboard_payment_refundable_value')}</label>
          <label className='content-data'>{priceLeft} <i className={`fa fa-${currency.toLowerCase()} content-data`}></i></label>
        </div>
        <div className='section-data' style={{ width:'80%' }}>
          <label className='title-data'>{I18n.t('dashboard_terminal')}</label>
          <label className='content-data'>{terminal}</label>
        </div>
      </div>
      {/* fecha y Hora */}
      <div className='section-container'>
        <div className='section-data'>
          <label className='title-data'>{I18n.t('dashboard_payment_date')}</label>
          <label className='content-data'>{orderDate? date: ''}</label>
        </div>
        <div className='section-data' style={{ width:'80%' }}>
          <label className='title-data'>{I18n.t('dashboard_hour')}</label>
          <label className='content-data'>{orderDate? time: ''}</label>
        </div>
      </div>
      {/* descripcion producto */}
      <div className='section-container'>
        <div className='section-data'>
          <label className='title-data'>{I18n.t('dashboard_payment_product_description')}</label>
          <label className='content-data'>{concepto}</label>
        </div>
      </div>
      {/* autorizacion */}
      <div className='section-container'>
        <div className='section-data'>
          <label className='title-data'>{I18n.t('dashboard_payment_authorization')}</label>
          <label className='content-data'>{authorization}</label>
        </div>
      </div>
      {/* proveedor */}
      <div className='section-container'>
        <div className='section-data'>
          <label className='title-data'>{I18n.t('dashboard_provider')}</label>
          {provider?
            <img src={getStaticImage(
              `/logo-${provider === 'redsys'? provider + '.png': provider + '.svg'}`
            )} alt={provider} className={'logo-provider'} />
            :
            <label className='content-data'>{provider}</label>
          }
        </div>
      </div>
    </div>
  )
}

export default InfoPayment